import { type IPublicClientApplication } from '@azure/msal-browser';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { CustomNavigationClient } from './CustomNavigationClient';

// @ai-generated 2026-10-29T10:48:14+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
/** Lets MSAL navigate inside the app through react-router instead of reloading the page. */
export function useMsalNavigation(pca: IPublicClientApplication) {
    const navigate = useNavigate();

    useEffect(() => {
        pca.setNavigationClient(new CustomNavigationClient(navigate));
    }, [navigate, pca]);
}
